export const LOGIN = "/:id?";
export const HOME = "/home";
/* export const PROFILEPAGE = "/profileLanding"; */
export const COUNTER = "counter";
export const RESET = "resetPassword/:id/:email/:token";
export const FORGOTPASSWORD = "forgotPassword";
export const PROFILE = "profile";
export const MYMESSAGES = "messages";
export const CHANGEPASSWORD = "changePwd";
export const VIEWMESSAGES = "messages/:role/:id";
export const LOAD = "loading";
export const MYLOUIETASKS = "mylouietasks";
// Stateless OIDC handoff target. The .NET callback returns a small HTML page that
// stashes an AES-GCM-encrypted token blob in sessionStorage and redirects here.
// AuthComplete reads the blob, exchanges it via /api/getdetails, and navigates to HOME.
export const AUTH_COMPLETE = "auth/complete";
export const PROFILE_ERROR = "auth/profile-error";
export const IFRAME = "iframe";
export const AGENTSCHEDULING = "agentscheduling";
export const INCOM = "digitalForm";
export const INCOMPLIANCEDASH = "compliance-dashboard"; // India Compliance Dashboard route
export const INDIA_COMPLIANCE_DASHBOARD = () => "/ORNHSched/getIndiaComplianceDashboard";
export const INDIA_COMPLIANCE_DASHBOARD_ACCESS = () => "/ORNHSched/getIndiaComplianceDashboardAccess";
export const DOWNLOAD_INDIA_COMPLIANCE_REPORT = () => "/ORNHSched/downloadIndiaComplianceReport";
export const DOWNLOAD_COMPLIANCE_PDF = () => "/ORNHSched/downloadCompliancePdf";

export const BASE_URL = "https://tteconnect-prod.ttec.com/";
// export const BASE_URL = `http://localhost:3000/`;
export const MIDDLE_WARE_BASE_URL = () =>
  `https://tteconnect-prod.ttec.com/api/v2/`;
// export const MIDDLE_WARE_BASE_URL = () => `https://localhost:3000/api/v2/`;
export const MIDDLE_WARE_BASE_URL_v1 = () =>
  `https://tteconnect-prod.ttec.com/api/v1`;
// export const MIDDLE_WARE_BASE_URL_v1 = () => `http://localhost:3000/api/v1`;
export const CALL_PPOR_API = () => `/PPORAPI/callPPORAPIs`;
export const NON_LOGIN_CALLS_API = () => `NonLogin/nonLoginCalls`;
export const NON_LOGIN_REGISTER_API = () => `NonLogin/registerUSer`;
export const NON_LOGIN_RESET_PASSWORD_API = () => `NonLogin/resetPassword`;
export const NON_SSO_LOGIN_API = () => `NonSSOLogin/login`;
export const CHG_PWD_INT_API = () => `NonSSOLogin/cngPSInitial`;
export const NON_SSO_REVALIDATE_LOGIN_API = () => `NonSSOLogin/reValidateLogin`;
export const NON_SSO_LOGIN_REFRESH_TOKEN_API = () =>
  `NonSSOLogin/refresh-token`;
export const NON_SSO_CHANGE_PASSWORD = () => `NonSSOLogin/changePassword`;
export const CLASSIFY_IDENTIFIER_API = () => `NonSSOLogin/classify`;

export const PRODUCTION_SCHEDULE = () =>
  `/AgentScheduling/GetAvailableSchedule`;
export const SAVE_USAGE_LOG = () =>
  `/AgentScheduling/saveUsageLogsWithConfirmation`;
export const REQUEST_ALTERNATIVE_SCHEDULE = () =>
  "/AgentScheduling/requestAlternativeSchedule";
export const REVOKE_CANDIDACY = () => "/AgentScheduling/revokeOrSubmitConcerns";
export const GET_CONFIRM_AGENT_SCHEDULE = () =>
  "/AgentScheduling/GetConfirmAgentScheduleForUser";
export const SUBMIT_ASKNOW_TICKET = () =>
  `/AskNowIncidentTicket/CreateAskNowIncidentTicket`;

export const LOUIE_ENV_TYPE = process.env.REACT_APP_LOUIE_ENV_TYPE as string;
export const LOUIE_BOT_ID = process.env.REACT_APP_LOUIE_BOT_ID as string;
export const LOUIE_BOT_URL = process.env.REACT_APP_LOUIE_BOT_URL as string;

// export const BASE_URL = "http://localhost:3000/";
// export const MIDDLE_WARE_BASE_URL = () => `http://localhost:3000/api/v1/`;
